import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, RequireAuth } from "./auth";
import Landing from "./pages/Landing";
import Ironlifts from "./pages/Ironlifts";
import Admin from "./pages/Admin";
import AdminOverview from "./pages/AdminOverview";
import AdminStudent from "./pages/AdminStudent";
import AdminPrograms from "./pages/AdminPrograms";
import Account from "./pages/Account";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app" element={<RequireAuth><Ironlifts /></RequireAuth>} />
          <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth adminOnly><Admin /></RequireAuth>} />
          <Route path="/admin/overview" element={<RequireAuth adminOnly><AdminOverview /></RequireAuth>} />
          <Route path="/admin/students/:id" element={<RequireAuth adminOnly><AdminStudent /></RequireAuth>} />
          <Route path="/admin/programs" element={<RequireAuth adminOnly><AdminPrograms /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
